"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONTEXT_PARAMS_LOCAL_STORAGE_KEY = exports.CONTEXT_PARAMS_HEADER_MAP = void 0;
/**
 * Maps context parameters to HTTP header keys
 */
exports.CONTEXT_PARAMS_HEADER_MAP = {
    view_name: 'x-chegg-view-name',
    view_experience: 'x-chegg-view-experience',
    view_feature: 'x-chegg-view-feature',
    view_property: 'x-chegg-view-property',
    view_version: 'x-chegg-view-version',
    previous_view_experience: 'x-chegg-previous-view-experience',
    previous_view_property: 'x-chegg-previous-view-feature',
    previous_view_name: 'x-chegg-previous-view-name',
    previous_view_feature: 'x-chegg-previous-view-property',
    conversation_id: 'x-chegg-conversation-id',
    search_id: 'x-chegg-search-id',
};
/**
 * Key of context parameters in window.localStorage
 */
exports.CONTEXT_PARAMS_LOCAL_STORAGE_KEY = 'rsw_view_previous_cache';



//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/checkout-sdk/dist/lib-esm/API/GraphApi/contextParams/constants.js
// module id = 1331
// module chunks = 11